/**
 * Submission Table Component (書類管理 — 提出一覧テーブル)

 */
import React from 'react';
import { Submission } from './types';
import './SubmissionTable.css';
import completedIcon from '../../../assests/icons/completed.png';

export interface SubmissionTableProps {
  /** Rows to display (already filtered by search/status in parent) */
  submissions: Submission[];
  /** Called when user clicks 開く or 続きから再開 */
  onOperationClick?: (submission: Submission) => void;
}

const SubmissionTable: React.FC<SubmissionTableProps> = ({
  submissions,
  onOperationClick,
}) => {
  const handleOperationClick = (e: React.MouseEvent, submission: Submission) => {
    e.stopPropagation();
    if (onOperationClick) {
      onOperationClick(submission);
    }
  };

  /** Status indicator: orange / blue / yellow dots or completed icon (完了) */
  const renderStatus = (status: Submission['status']) => {
    switch (status) {
      case 'submitted':
        return <span className="submission-table__status-dot submission-table__status-dot--orange" aria-hidden />;
      case 'resubmitted':
        return <span className="submission-table__status-dot submission-table__status-dot--blue" aria-hidden />;
      case 'resubmission_requested':
        return <span className="submission-table__status-dot submission-table__status-dot--yellow" aria-hidden />;
      case 'completed':
        return <img src={completedIcon} alt="" className="submission-table__status-icon" aria-hidden />;
      default:
        return null;
    }
  };

  return (
    <div className="submission-table">
      <div className="submission-table__container">
        <table className="submission-table__table">
          <thead>
            <tr>
              <th>番号</th>
              <th className="submission-table__th-status" aria-label="ステータス" />
              <th>氏名</th>
              <th>招待/再提出依頼日</th>
              <th>提出日</th>
              <th>提出時刻</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {submissions.length > 0 ? (
              submissions.map((submission, index) => (
                <tr key={submission.id} className="submission-table__row">
                  <td className="submission-table__cell-number">{index + 1}</td>
                  <td className="submission-table__cell-status">
                    {renderStatus(submission.status)}
                  </td>
                  <td>{submission.empName}</td>
                  <td>{submission.requestDate}</td>
                  <td>{submission.submittedDate}</td>
                  <td>{submission.submittedTime}</td>
                  <td>
                    <button
                      type="button"
                      className={`submission-table__operation submission-table__operation--${submission.operationType}`}
                      onClick={(e) => handleOperationClick(e, submission)}
                    >
                      {submission.operationType === 'open' && '開く'}
                      {submission.operationType === 'resume' && '続きから再開'}
                      {submission.operationType === 'finalize' && '登録完了処理'}
                      {submission.operationType === 'view' && '閲覧'}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="submission-table__empty">
                  提出データがありません
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubmissionTable;
